import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { formatDate } from "../../../../utils";

import { DRAM_LONG_DATES_GAP, PAIR_LAYOUT } from "../configs";
import { PlanningGridContext } from "../PlanningGrid";

export const RenderDates = ({
  columns = [],
  planning = {},
  realized = {},
  allowedKeys,
  releaseIndicator,
}) => {
  const { headerGroupsDatesLayout } = useContext(PlanningGridContext);
  return (
    // Sub-grid principal (5 colunas + gap)
    <Box
      display="grid"
      gridTemplateColumns={headerGroupsDatesLayout}
      gap={DRAM_LONG_DATES_GAP}
    >
      {columns.map((column, index) => {
        if (allowedKeys && !allowedKeys.includes(column.planningKey)) {
          return (
            // Grid interna do par (2 colunas)
            <Box key={index} display="grid" gridTemplateColumns={PAIR_LAYOUT} />
          );
        }
        return column.hideSubLabels ? (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              variant="body2"
              sx={{ fontSize: "12px", fontFamily: "inherit" }}
            >
              {formatDate(
                planning[column.planningKey] ||
                  realized[column.realizedKey],
                "-"
              )}
            </Typography>
          </Box>
          ) : (
            <Box
              key={index}
              display="grid"
              gridTemplateColumns={PAIR_LAYOUT}
              sx={{ position: "relative" }}
            >
              <Box display="flex" alignItems="center" justifyContent="center">
                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", fontFamily: "inherit" }}
                >
                  {formatDate(planning[column.planningKey], "-")}
                </Typography>
              </Box>

              <Box display="flex" alignItems="center" justifyContent="center">
                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", fontFamily: "inherit" }}
                >
                  {formatDate(realized[column.realizedKey], "-")}
                </Typography>
              </Box>

              {column.title === "LIBERAÇÃO" && releaseIndicator}
            </Box>
          );
      })}
    </Box>
  );
};
